export function formatNumber(num: string | number, keepTrailingZeros = false) {
  const parts = Number.parseFloat(`${num}`).toFixed(2).split('.');

  if (typeof parts[0] !== 'undefined') {
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (parts[1] === '00' && !keepTrailingZeros) return parts[0];
  return parts.join('.');
}
